export default {
  photos: {
    data: [],
    meta: {}
  },
  photo: {}
}
